import React from 'react'
import { some } from 'lodash'
import { ListGroup, ListGroupItem } from 'react-bootstrap'

import {nameOrTitle} from "../../lib/text"

const getStyleForMood = mood => {
  if (mood == "gud") return {
    color:"success",
    emoji:"😃"
  }
  else if (mood == "meh") return {
    color:"warning",
    emoji:"😐"
  }	 
  else if (mood == "sad") return {
    color:"danger",
    emoji:"😡"
  }
  else return { emoji: "⁇ " }
}

const ActivityFeedback = ({ feedbackItem, activity }) => {
  const style = getStyleForMood(feedbackItem.mood)
  
  return (
    <ListGroupItem bsStyle={style.color} key={activity._id}>
      <span style={{fontSize:20, fontWeight:"bold"}}>
        {style.emoji} {nameOrTitle(activity)}
      </span>
      <p style={{fontStyle: "italic"}}>{feedbackItem.text}</p>
    </ListGroupItem>
  )
}

const FeedbackList = ({trip, agenda, bill, feedback, Activities}) => (
  <div>
    <h3>Feedback</h3>

    <ListGroup>
      {
        bill
          .filter(section => section.sectionType == "day")
          .filter(section => (
            some(section.items, item => (feedback[item.key] && feedback[item.key].mood))
            || (feedback[section.dayNumber - 1] && feedback[section.dayNumber - 1].text)
          ))
          .map(section => (
            <ListGroupItem key={section.key}>
              <h4>Día {section.dayNumber}, {section.date}</h4>
              
              {
                // there is also a per-day general comment
                // it's keyed by its day *index*
                // i know it's weird, im sorry
                feedback[section.dayNumber - 1] && 
                feedback[section.dayNumber - 1].text && (
                  <p style={{fontStyle: "italic"}}>
                    {feedback[section.dayNumber - 1].text}   
                  </p>
                )
              }
    
              <ListGroup>
                {
                  section.items
                    .filter(item => feedback[item.key] && feedback[item.key].mood)
                    .map(item => (
                      <ActivityFeedback 
                        key={item.key}
                        feedbackItem={feedback[item.key]}
                        activity={Activities[item.activityId]}
                      />
                    ))
                }
              </ListGroup>
            </ListGroupItem>
          ))
      }
    </ListGroup>
  </div>
)
  
export default FeedbackList
